<!--[style]='obj.desktop && width ? {width: width+"px", maxWidth: width+"px", minWidth: width+"px"} : {}'-->
<div *ngIf='{ desktop: (deviceS.isDesktop$|async),
              mobile: (deviceS.isMobile$|async),
             } as obj' class='wrapperSwitcherBtn' [style]='style'>
  <div class='wrapperSwitcherBtn__btn wrapperSwitcherBtn__btn--{{btnActive.btn1 ? "btnActive":""}}'
       (click)='changeActiveBtn("btn1")'>{{text1}}</div>

  <div class='wrapperSwitcherBtn__btn wrapperSwitcherBtn__btn--{{btnActive.btn2 ? "btnActive":""}}'
       (click)='changeActiveBtn("btn2")'>{{text2}}</div>
</div>